import { render, staticRenderFns } from "./MyAtendimento.vue?vue&type=template&id=2a3aae38&"
import script from "./MyAtendimento.vue?vue&type=script&lang=js&"
export * from "./MyAtendimento.vue?vue&type=script&lang=js&"
import style0 from "./MyAtendimento.vue?vue&type=style&index=0&id=2a3aae38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports